import React, { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import Style from './BannerImage.css'

const BannerImage = (props) => {
  const [ref, inView] = useInView({
    threshold: 0,
  })

  useEffect(() => {
    if (inView) {
      props.setSection()
    }
  })

  return (
    <section ref={ref} className={`banner-image ${props.className}`}>
      <div className={`container ${props.extraClass}`}>
        <img src={props.bannerImage} alt={props.altText} />
      </div>
    </section>
  )
}

export default BannerImage
